"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
const language_manifest_json_1 = __importDefault(require("./config/language.manifest.json"));
// @ts-ignore
const enterprise_1 = require("./enterprise");
function loadAllLang() {
    let strings = {};
    if (typeof window !== 'undefined') {
        strings = window.apitable_i18n || {};
    }
    else {
        strings = global.apitable_i18n || {};
    }
    console.log('language package keys: ', Object.keys(strings));
    const newStrings = {};
    for (const key in strings) {
        if (enterprise_1.strings) {
            newStrings[key] = Object.assign(Object.assign({}, strings[key]), enterprise_1.strings[key]);
        }
        else {
            newStrings[key] = strings[key];
        }
    }
    if (typeof window !== 'undefined') {
        window.apitable_i18n = newStrings;
        window.languageManifest = language_manifest_json_1.default;
    }
    else {
        global.apitable_i18n = newStrings;
        global.languageManifest = language_manifest_json_1.default;
    }
}
loadAllLang();
